<template>
    <div>
      <main class="manager_content_main">
        <div class="WorkM_MainArea">
          <b-container fluid>
            <div class="WorkM_MailResend">
              
              <div class="WorkM_MailResendTitleArea">
                <div class="TitleItem_TitleLabel"><b-icon icon="envelope" class="mr-2"></b-icon>メール送信履歴・再送信</div>
              </div>
             
              <div class="WorkM_MailResendConditionArea">
                <div class="ConditionRow d-flex">
                  <div class="ConditionEachArea mr-5">
                    <b-form-radio-group id="condition_target" v-model="conditionTarget" size="sm" button-variant="outline-primary" buttons>
                      <label class="labelTitle pr-4">対象</label>
                      <b-radio value="0">すべて</b-radio>
                      <label class="spacer" />
                      <b-radio value="1">未確認</b-radio>
                      <label class="spacer" />
                      <b-radio value="2">確認済</b-radio>
                    </b-form-radio-group>
                  </div>
                  <div class="ConditionEachArea">
                    <b-form-group id="condition_sendDate">
                      <div class="d-flex">
                        <label class="labelTitle">送信日</label>
                        <b-form-datepicker class="inputDateTime" v-model="conditionSendDateFrom" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short' }" label-no-date-selected="yyyy/mm/dd" size="sm"></b-form-datepicker>
                        <label class="labelTitle pl-2">～</label>
                        <b-input type="date" style="width: 10em;" size="sm"></b-input>
                        <!--
                        <b-form-datepicker class="inputDateTime" v-model="conditionSendDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short' }" label-no-date-selected=""></b-form-datepicker>
                        -->
                      </div>
                    </b-form-group>
                  </div>
                </div>
                <div class="ConditionRow d-flex">
                  <div class="ConditionEachArea">
                    <b-form-group id="condition_request_person">
                      <div class="d-flex">
                        <label class="labelTitle">送信者</label>
                        <b-form-input class=inputShainCode v-model="conditionRequestShainCode" size="sm"></b-form-input>
                        <label class="labelItem pl-2">山田 一郎</label>
                      </div>
                    </b-form-group>
                  </div>
                </div>
                <div class="ConditionRow d-flex">
                  <div class="ConditionEachArea">
                    <b-form-group id="condition_approval_person" class="mb-0">
                      <div class="d-flex">
                        <label class="labelTitle pr-4">宛先</label>
                        <b-form-input class=inputShainCode v-model="conditionApprovalShainCode" size="sm"></b-form-input>
                        <label class="labelItem pl-2">田中 花子</label>
                      </div>
                    </b-form-group>
                  </div>
                </div>
              </div>
              <!-- 一覧 -->
              <div class="WorkM_MainResendListArea">
                <div class="OperationRow mt-2">
                  <b-row>
                    <b-col cols="4">
                      <div class="d-flex">
                        <b-button class="mr-2 py-2" size="sm" variant="outline-success" @click="selectAllRows">全選択</b-button>
                        <b-button class="mr-2 py-2" size="sm" variant="outline-danger" @click="clearSelected">選択解除</b-button>
                      </div>
                    </b-col>
                    <b-col cols="4">
                      <div class="d-flex justify-content-end dummyMargin">
                        <label class="selectedStatus mt-auto">選択</label>
                        <label class="selectedStatus mt-auto pl-2 pr-2">{{checkCount}}</label>
                        <label class="selectedStatus mt-auto">件</label>
                      </div>
                    </b-col>
                    <b-col cols="4">
                      <div class="d-flex justify-content-end">
                        <label class="selectedStatus mt-auto mr-1">チェックしたメール</label>
                        <b-button class="py-2" variant="success" size="sm" @click="clickExecResend()">再送信</b-button>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="mt-2">
                  <b-table id="mail-history-table" :items="mailHisotryList" :fields="mailHistoryFields" responsive="sm" small striped>
                    <template v-slot:cell(sendTarget)="data">
                      <b-form-checkbox v-model="data.item.sendTarget" size="sm" value="1" unchecked-value="0" @change="checkedChanged(data.item.sendTarget)"></b-form-checkbox>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </b-container>
        </div>
      </main>
    </div>
  </template>
  
  <script>
  // import moment from "moment";
  import config from "../../const/config";
  export default {
    name: "MailSend",
    components: {},
    data() {
      return {
        systemVersion: null,
        conditionTarget: '0',
        conditionSendDateFrom: '',
        conditionSendDateTo: '',
        conditionRequestShainCode: '1023456',
        conditionApprovalShainCode: '2012345',
        checkCount: 0,
        mailHistoryFields: [
          {
            key: 'sendTarget',
            label: '再送',
            thClass: 'table-header',
            class: 'width-send-target',
          },
          {
            key: 'sendDate',
            label: '送信日',
            thClass: 'table-header',
            class: 'width-send-date',
          },
          {
            key: 'requestShainName',
            label: '送信者',
            thClass: 'table-header',
            class: 'width-request-shain-name',
          },
          {
            key: 'approvalShainName',
            label: '宛先',
            thClass: 'table-header',
            class: 'width-approval-shain-name',
          },
          {
            key: 'reason',
            label: '事由',
            thClass: 'table-header',
            class: 'width-reason',
          },
          {
            key: 'title',
            label: 'タイトル',
            thClass: 'table-header',
            class: 'width-title',
          },
          {
            key: 'checkDate',
            label: '確認日',
            thClass: 'table-header',
            class: 'width-check-date',
          },
          {
            key: 'resendDate',
            label: '再送信日',
            thClass: 'table-header',
            class: 'width-resend-date',
          },
        ],
        mailHisotryList: [
          {
            mailId: 5,
            sendTarget: 0,
            sendDate: "2024/08/20",
            requestShainCode: "1023456",
            requestShainName: "山田 一郎",
            approvalShainCode: "2012345",
            approvalShainName: "田中 花子",
            reason: "有休",
            title: "有給休暇の申請",
            checkDate: "",
            resendDate: "",
          },
          {
            mailId: 4,
            sendTarget: 0,
            sendDate: "2024/08/18",
            requestShainCode: "1023456",
            requestShainName: "山田 一郎",
            approvalShainCode: "2012345",
            approvalShainName: "田中 花子",
            reason: "交通規制による都合",
            title: "休日出勤の申請",
            checkDate: "2024/08/19",
            resendDate: "",
          },
          {
            mailId: 3,
            sendTarget: 0,
            sendDate: "2024/08/12",
            requestShainCode: "1023456",
            requestShainName: "山田 一郎",
            approvalShainCode: "2012345",
            approvalShainName: "田中 花子",
            reason: "交通規制による都合",
            title: "残業申請",
            checkDate: "",
            resendDate: "2024/08/17",
          },
          {
            mailId: 2,
            sendTarget: 0,
            sendDate: "2024/08/12",
            requestShainCode: "1023456",
            requestShainName: "山田 一郎",
            approvalShainCode: "2012345",
            approvalShainName: "田中 花子",
            reason: "交通規制による都合",
            title: "遅刻申請",
            checkDate: "2024/08/16",
            resendDate: "",
          },
          {
            mailId: 1,
            sendTarget: 0,
            sendDate: "2024/08/10",
            requestShainCode: "1023456",
            requestShainName: "山田 一郎",
            approvalShainCode: "2012345",
            approvalShainName: "田中 花子",
            reason: "勤務承認",
            title: "勤務の承認処理依頼",
            checkDate: "2024/08/13",
            resendDate: "",
          },
        ],
      };
    },
    computed: {},
    watch: {},
    mounted: function () {
      this.systemVersion = this.$store.getters.getSystemVersion;
    },
  
    methods: {
      getDispSegment: function (segmentCd) {
        let optionSegment = config.OPTIONS.WORK_SEGMENT_SIMPLE;
        let result = "";
        optionSegment.forEach((element) => {
          if (element.value == segmentCd) {
            result = element.text;
          }
        });
        return result;
      },

      selectAllRows() {
      },
      clearSelected() {
      },

      /**
       * 一覧のCheckBox状態変更時処理
       */
      checkedChanged: function(checked) {
        if (checked == 1) {
          this.checkCount++;
        } else {
          this.checkCount--;
        }
      },

      /**
       * [再送信]ボタン押下時処理
       */
      clickExecResend: function() {
        /*
        let checked = "";
        this.mailHisotryList.forEach(function(mailHistory){
          if (checked.length > 0) {
            checked += ', ';
          }
          checked += mailHistory.sendTarget;
        });
        alert(checked);
        */
      }
    },
  };
  </script>
  <style>
  .none{
    /* display: none; */
  }
  fieldset.form-group {
    margin-bottom: 0.5rem;
  }
  div.inputDateTime {
    width: 12em;
  }
  label.labelTitle {
    padding-right: 10px;
    padding-top: 0.3rem;
    margin-bottom: 0rem;
    font-size: 0.875rem;
    font-weight: bold;
  }
  label.labelItem {
    padding-right: 10px;
    padding-top: 0.3rem;
    margin-bottom: 0rem;
    font-size: 0.875rem;
  }
  label.spacer {
    padding-right: 0.5rem;
  }
  input.inputShainCode {
    width: 6em;
  }
  .WorkM_MailResend {
    padding: 0 1rem;
  }
  .WorkM_MailResendTitleArea {
    width: 100%;
    padding-bottom: 1rem;
    /*border-bottom: 1px solid rgb(82, 75, 75);*/
  }
  .TitleItem_TitleLabel {
    width: 100%;
    text-align: center;
  }
  .WorkM_MailResendConditionArea {
    padding: 1rem;
    border-top: 1px solid rgb(82, 75, 75);
    border-bottom: 1px solid rgb(82, 75, 75);
  }

  .selectedStatus {
    font-size: 0.875rem;
  }
  .dummyMargin {
    margin-top: 11px;
  }

  #mail-history-table {
    font-size: 0.875rem;
  }
  #mail-history-table .table-header {
    font-weight: bold;
    background-color: rgb(204, 211, 255);
  }
  #mail-history-table .width-send-target {
    width: 5%;
  }
  #mail-history-table .width-send-date {
    width: 10%;
  }
  #mail-history-table .width-request-shain-name {
    width: 10%;
  }
  #mail-history-table .width-approval-shain-name {
    width: 10%;
  }
  #mail-history-table .width-check-date {
    width: 10%;
  }
  #mail-history-table .width-resend-date {
    width: 10%;
  }
  
  .WorkM_ApplicationHeader {
    display: flex;
    justify-content: center;
    padding: 1rem;
    font-size: 1.2rem;
  }
  .ConditionStartDate {
    width: 280px;
  }
  
  .WorkM_ApprovalListArea {
    height: 500px;
  }
  
  .WorkM_ApplicationItem {
    display: flex;
    margin-bottom: 0.7rem;
    background: rgb(237, 237, 238);
    box-shadow: 2px 2px 3px rgb(230, 230, 230);
    border-radius: 5px;
    height: 100%;
  }
  .WorkM_ApplicationItem_HeaderArea {
    font-size: 0.9rem;
    height: 100%;
    width: 5.5rem;
  }
  .SegmentLabel {
    padding: 4px;
    width: 100%;
    background: rgb(24, 103, 194);
    color: rgb(255, 255, 255);
    font-weight: 700;
    border-radius: 5px 0 0 0;
    min-width: 4rem;
    text-align: center;
  }
  
  .ApprovalSelectArea {
    margin-top: 0.5rem;
  }
  .ApprovalSelectArea .ApprovalLabel {
    padding-left: 0.5rem;
    color: rgb(29, 116, 50);
    text-align: left;
  }
  .ApprovalSelectArea .NonApprovalLabel {
    padding-left: 0.5rem;
    color: red;
    text-align: left;
  }
  
  .WorkM_ApplicationItem_DetailArea {
    padding: 0.2rem 0.5rem 0.5rem 0.5rem;
    flex-grow: 1;
    background: #f5f5f5;
  }
  .WorkM_ApplicationItem_DetailArea .ApplicationDate {
    font-size: 0.85rem;
    display: flex;
    font-weight: 700;
    padding: 0.1rem;
  }
  .WorkM_ApplicationItem_DetailArea .DetailItem {
    display: flex;
    font-size: 0.75rem;
  }
  .WorkM_ApplicationItem_DetailArea .DetailItem_TitleLabel {
    width: 3rem;
  }
  </style>
  